import { ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Inject, Injector, Input, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TypeConverter } from '@farris/ide-property-panel';
import { LoadingService } from '@farris/ui-loading';
import { MessagerService } from '@farris/ui-messager';
import { BsModalService } from '@farris/ui-modal';
import { NotifyService } from '@farris/ui-notify';
import { GSPViewModel } from '@gsp-bef/gsp-vo-metadata';
import { Metadata4RefDto, SelectMetadataRTComponent } from '@gsp-lcm/metadatart-selector';
import { FrameworkService } from '@gsp-sys/rtf-common';
import { BillTypeHelpComponent } from '../bill-type-help/bill-type-help/bill-type-help.component';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

type VoConfig = {
  currentVoId?: string;
  currentVoName?: string;
  currentDocumentTypeId?: string;
  currentDocumentTypeName?: string;
};

@Component({
  selector: 'lib-vo-config',
  templateUrl: './vo-config.component.html',
  styleUrls: [],
  providers: [
     WfLocalePipe,
  ]
})
export class VoConfigComponent implements OnInit {
  readonly groupIcon = '<i class="f-icon f-icon-lookup"></i>';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(data: VoConfig) {
    if (data) {
      this.entity = data || {};
    }
  }

  @Input() editorParams: {
    bizTypeId?: string
  } = {};

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  modalConfig = {
    title: this.localePipe.transform("component.voConfig.documentInfo"),
    width: 500,
    height: 240,
    showButtons: true
  };

  entity: VoConfig = {};

  constructor(
    private messager: MessagerService,
    private notify: NotifyService,
    private modal: BsModalService,
    private framework: FrameworkService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private loading: LoadingService,
    private cfr: ComponentFactoryResolver,
    private inj: Injector,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
  }

  clickOk() {
    const obj = { value: this.entity, parameters: null };
    this.submitModal.emit(obj);
  }

  clickCancel() {
    this.closeModal.emit();
  }

  selectVo() {
    const compFactory = this.cfr.resolveComponentFactory(SelectMetadataRTComponent);
    const compRef = compFactory.create(this.inj);
    compRef.instance.typeList = 'GSPViewModel';
    // 元数据选择器bizTypeId表示业务种类Id
    compRef.instance.bizTypeId = this.editorParams && this.editorParams.bizTypeId;

    compRef.instance.selectedMetadata.subscribe(
      (metadata4RefDto: Metadata4RefDto) => {
        this.clearVo();
        const voDto = metadata4RefDto.metadata;
        const vo: GSPViewModel = JSON.parse(voDto.content);

        this.entity.currentVoId = vo.ID;
        this.entity.currentVoName = vo.Name;
      },
      (err) => {
        console.error(err);
        // todo 确定异常结构, 目前采用兼容取值方式
        this.messager.error(err.error == null ? err.message : (err.error.Message || err.error.message || err.message));
        this.clearVo();
      }
    );

    const modalConfig = {
      title: this.localePipe.transform("component.voConfig.viewModelSelection"),
      width: 930,
      height: 573,
      showButtons: false
    };
    const dialog = this.modal.show(compRef, modalConfig);
    compRef.instance.closeModalEmitter.subscribe($event => dialog.close());
  }

  clearVo() {
    this.entity.currentVoId = undefined;
    this.entity.currentVoName = undefined;
  }

  selectDocuType() {
    const cmpF = this.cfr.resolveComponentFactory(BillTypeHelpComponent);
    const cmpR = cmpF.create(this.inj, []);
    cmpR.instance.docuTypeId = this.entity.currentDocumentTypeId;

    const buttons = [];
    buttons.push(
      {
        text: this.localePipe.transform("component.voConfig.cancel"),
        cls: "btn btn-secondary",
        handle: () => {
          bsModal && bsModal.close();
        }
      }
    );

    buttons.push(
      {
        text: this.localePipe.transform("component.voConfig.clickOk"),
        cls: "btn btn-primary",
        handle: () => {
          const docuType = cmpR.instance.getSelectedDocuType();
          if (docuType == null) {
            this.notify.warning(this.localePipe.transform("component.voConfig.selectOne"));
            return;
          }
          this.entity.currentDocumentTypeId = docuType.id;
          this.entity.currentDocumentTypeName = docuType.name;
          bsModal && bsModal.close();
        }
      },
    );

    const bsModal = this.modal.show(cmpR, {
      title: this.localePipe.transform("component.voConfig.documentTypeSelect"),
      height: 573,
      width: 930,
      buttons: buttons,
      showMaxButton: false,
    });
  }

  clearDocuType() {
    this.entity.currentDocumentTypeId = undefined;
    this.entity.currentDocumentTypeName = undefined;
  }
}

export class VoConfigConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: VoConfig): string {
    if (data && data.currentVoId) {
      return data.currentVoName || data.currentVoId || this.localePipe.transform("component.voConfig.set");
    }
    return this.localePipe.transform("component.voConfig.notSet");
  }
}
